module.exports = __webpack_public_path__ + "static/media/wellhub.0561966d.png";